const localStorage = require("./localStorage");

/**
 * Simple localStorage wrapper (consent checking temporarily disabled)
 */
const consentAwareStorage = {
  setItem: function(key, value) {
    localStorage.setItem(key, value);
  },
  getItem: function(key) {
    return localStorage.getItem(key);
  },
  removeItem: function(key) {
    localStorage.removeItem(key);
  }
};

module.exports = consentAwareStorage;